module.exports = __webpack_public_path__ + "img/d6.9187d69e.png";